export default __webpack_public_path__ + "static/media/twitter-v1-rt30.29189f06.svg";